module.exports = __webpack_public_path__ + "daf9b9f4c40078899185cdf85066ddd4.png";